const postDimensions = {
  desktopStandard: { height: 139 },
}

const renderDisplayLayout = {
  desktopStandard: {
    minHeight: postDimensions.desktopStandard.height,
  },
}

const baseStyles = (display, isPresenting) => ({
  ...renderDisplayLayout[display],
  backgroundColor: 'white',
  borderRadius: '0px',
  display: 'flex',
  flexDirection: 'column',
  width: isPresenting ? '480px' : '570px',
})

export { baseStyles }
